module.exports = __webpack_public_path__ + "img/hk_room_floorplan_06_en.ca0a434a.png";